module.exports = __webpack_public_path__ + "img/establishment-role.149b96e9.svg";